import * as React from 'react';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { updateItemsOrder, selectLanguageAndLoadEditorMenuItems, publishMenu, resetAllData } from 'modules/menueditor';
import { showModal, closeModal } from 'modules/modal';
import { IMenuEditor, IMenuEditorAction } from 'models/menueditor/menueditor';
import { ILanguage } from 'models/common';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { ErrorPage } from 'containers';
import { FilteredPage } from 'components/PortalStructure';
import { IMenuItemListItem } from 'models/menuitem/menuitemlistitem';
import SortableTree, { removeNodeAtPath, TreeItem } from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import { MenuItemType } from 'models/enums/menuitemtype';
import { getMenuItemTypeByPathname } from 'helpers/common';

require('./style.css');

interface IProps {
	menuEditor: IMenuEditor;
	languageDomainValues: ILanguage[];
	location: any;

	/* func props */
	updateItemsOrder?: (newItemsOrder: TreeItem[]) => IMenuEditorAction;
	selectLanguageAndLoadEditorMenuItems?: (selectedLanguageKey: number, menuItemType: MenuItemType) => IMenuEditorAction;
	publishMenu?: (menuItemType: MenuItemType) => IMenuEditorAction;
	resetAllData?: () => IMenuEditorAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		menuEditor: state.menuEditor,
		languageDomainValues: state.domainValues.languages,
	}),
	(dispatch) => ({
		updateItemsOrder: (newOrder: IMenuItemListItem[]) => dispatch(updateItemsOrder(newOrder)),
		selectLanguageAndLoadEditorMenuItems: (selectedLanguageKey: number, menuItemType: MenuItemType) =>
			dispatch(selectLanguageAndLoadEditorMenuItems(selectedLanguageKey, menuItemType)),
		publishMenu: (menuItemType: MenuItemType) => dispatch(publishMenu(menuItemType)),
		resetAllData: () => dispatch(resetAllData()),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MenuEditor extends React.Component<IProps, {}> {
	private menuItemType: MenuItemType;

	constructor(props) {
		super(props);

		this.openMenuItemTypeSelector = this.openMenuItemTypeSelector.bind(this);
		this.handleLanguageChange = this.handleLanguageChange.bind(this);
		this.publishMenu = this.publishMenu.bind(this);
		this.cancelClick = this.cancelClick.bind(this);
	}

	public componentDidMount() {
		this.menuItemType = getMenuItemTypeByPathname(this.props.location.pathname);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			this.menuItemType = getMenuItemTypeByPathname(this.props.location.pathname);
			this.props.resetAllData();
		}
	}

	public componentWillUnmount() {
		this.props.resetAllData();
	}

	private openMenuItemTypeSelector() {
		this.props.showModal('MenuTypeSelector', {
			closeModal: this.props.closeModal,
			showModal: this.props.showModal,
			showHeaderCloseButton: true,
			menuItemType: this.menuItemType,
		});
	}

	private handleLanguageChange(val: number) {
		if (val) {
			this.props.selectLanguageAndLoadEditorMenuItems(val, this.menuItemType);
		} else {
			this.props.resetAllData();
		}
	}

	private cancelClick() {
		browserHistory.push('/');
	}

	private publishMenu() {
		this.props.publishMenu(this.menuItemType);
	}

	private showAddItemButton(show: boolean) {
		if (!show) {
			return null;
		}

		return (
			<button type="button" className="addItem" onClick={this.openMenuItemTypeSelector}>
				{' '}
				<img src={require('containers/Html/icons/add_section_icon.svg')} className="icon" />
			</button>
		);
	}

	public render() {
		if (this.props.menuEditor.error) {
			return <ErrorPage {...this.props} message={this.props.menuEditor.message} />;
		}

		const { items, selectedLanguageKey } = this.props.menuEditor;
		const { t } = this.props;

		let languageOptions = [];
		if (this.props.languageDomainValues.length > 0) {
			languageOptions = this.props.languageDomainValues.map((language: ILanguage) => {
				return {
					key: language.key,
					value: language.value,
				};
			});
		}

		const topBarProps: object = {
			leftFilterTitle: t('BSPortal_Common_Filter_Language'),
			leftFilterKey: selectedLanguageKey,
			leftFilterOptions: languageOptions,
			onSaveButtonClick: this.publishMenu,
			saveButtonText: t('BSPortal_Common_Save'),
			onLeftFilterChange: this.handleLanguageChange,
		};

		const getNodeKey = ({ treeIndex }) => treeIndex;

		return (
			<FilteredPage filterBarOptions={topBarProps} childIsList={false}>
				<div className="menuEditor">
					<div className="panel">
						<h2 className="title">{t('Magazine_MagazineMenu_MagazineMenuEditor_Title')}</h2>
						<div style={{ height: 400 }}>
							<SortableTree
								treeData={items}
								onChange={(itemsToUpdate) => {
									this.props.updateItemsOrder(itemsToUpdate);
								}}
								generateNodeProps={({ path }) => ({
									buttons: [
										<button
											onClick={() => {
												this.props.updateItemsOrder(removeNodeAtPath({ treeData: items, path, getNodeKey }));
											}}
											key={`button1`}
										>
											{this.props.t('BSPortal_Common_Remove')}
										</button>,
									],
								})}
							/>
						</div>
						{this.showAddItemButton(selectedLanguageKey ? true : false)}
					</div>
				</div>
			</FilteredPage>
		);
	}
}

export { MenuEditor };
